import request from '@/utils/request'

// 查询培训类型列表
export function listTrainType(query) {
  return request({
    url: '/h5/trainType/list',
    method: 'get',
    params: query
  })
}
